import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { UserContext } from '@/providers/userContextProvider';
import { initAnalytics, sendAnalyticsEvent } from '@/util/analytics/analytics';

type AnalyticsContextType = {
  sendAnalytic: (props: string, meta?: any) => void;
};

export interface AnalyticsProviderType {
  type: AnalyticsProviderTypes;
  id: string;
}

export enum AnalyticsProviderTypes {
  GOOGLE = 'GOOGLE',
  DATADOG = 'DATADOG',
}

const firebaseDefaultConfig = {
  apiKey: process.env.REACT_APP_ANALYTICS_API_KEY ?? '',
  authDomain: process.env.REACT_APP_ANALYTICS_AUTH_DOMAIN ?? '',
  projectId: process.env.REACT_APP_ANALYTICS_PROJECT_ID ?? '',
  storageBucket: process.env.REACT_APP_ANALYTICS_STORAGE_BUCKET ?? '',
  messagingSenderId: process.env.REACT_APP_ANALYTICS_MESSAGING_SENDER_ID ?? '',
  appId: process.env.REACT_APP_ANALYTICS_APP_ID ?? '',
  measurementId: process.env.REACT_APP_ANALYTICS_MEASUREMENT_ID ?? '',
};

const AnalyticsContext = createContext<AnalyticsContextType>({
  sendAnalytic: () => {},
});
const AnalyticsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { userContext, activeEntity } = useContext(UserContext);
  const [lastSendEvent, setLastSentEvent] = useState<string>('');

  const [provider] = useState<AnalyticsProviderType[]>([
    {
      type: AnalyticsProviderTypes.GOOGLE,
      id: '', // todo: add ID for analytics
    },
    {
      type: AnalyticsProviderTypes.DATADOG,
      id: '', // todo: add ID for analytics
    },
  ]);

  // const { permissions } = usePermissions();
  const getDefaultFirebase = () => {
    try {
      initAnalytics({
        provider: AnalyticsProviderTypes.GOOGLE,
        providerId: '', //todo: set providerId
        configType: firebaseDefaultConfig,
      });
    } catch (e) {
      /* empty */
    }
  };

  const sendAnalytic = useCallback(
    (event: string, meta?: any) => {
      if (event === lastSendEvent) return;
      const mergedMeta = {
        ...meta,
      };
      sendAnalyticsEvent(provider, event, mergedMeta).then();
      setLastSentEvent(event);
      /* eslint-disable react-hooks/exhaustive-deps */
    },
    [lastSendEvent],
  );

  // [TODO]: add different methods to log Error. events, info as well.
  // Separate LOGS from EVENTS.

  useEffect(() => {
    getDefaultFirebase();
  }, [activeEntity, userContext]);

  return (
    <AnalyticsContext.Provider value={{ sendAnalytic }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export { AnalyticsProvider, AnalyticsContext };
